<onyx-tabs
  [tabs]="TABS"
  [(value)]="category"
  [fill]="true"
  width="100%"
></onyx-tabs>

@switch (category()) {
  @case (OnyxIconPickerCategory.ICONS) {
    <div class="group scrollable">
      @for (icon of ICONS; track icon) {
        <div
          class="icon"
          [class.active]="value() === icon"
          tabindex="-1"
          (click)="value.set(icon)"
          (keydown)="(null)"
        >
          <onyx-icon [name]="icon" [size]="16"></onyx-icon>
        </div>
      }
    </div>
  }

  @case (OnyxIconPickerCategory.EMOJIS) {
    <onyx-search [(query)]="query" color="light-gray" [size]="32"></onyx-search>

    <cdk-virtual-scroll-viewport class="scrollable" [itemSize]="32">
      <div
        *cdkVirtualFor="let item of emojiGroups(); trackBy: itemTrackBy"
        class="item"
      >
        @if ('label' in item) {
          <p class="f-body-xs f-medium f-muted">
            {{ item.label | translate }}
          </p>
        } @else {
          <div class="group">
            @for (emoji of item.group; track emoji) {
              <div
                class="icon"
                [class.active]="value() === emoji"
                tabindex="-1"
                (click)="value.set(emoji)"
                (keydown)="(null)"
              >
                <onyx-emoji [name]="emoji" [size]="20"></onyx-emoji>
              </div>
            }
          </div>
        }
      </div>
    </cdk-virtual-scroll-viewport>
  }
}
